import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pin",
  "use": "pin-usage",
  "viewBox": "0 0 9 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 9 15\" id=\"pin\">\n<path d=\"M1.6,0.2C1.5,0.3,1.4,0.4,1.4,0.6l0,0.1l0.7,4h3.9l0.7-4c0-0.2,0-0.4-0.1-0.5C6.6,0.1,6.5,0,6.4,0L2,0\n\tC1.8,0,1.7,0.1,1.6,0.2z M0.9,6.7C0.3,7.3,0,8.1,0,8.9l3.6,0v4.9c0,0.2,0.1,0.4,0.3,0.5c0.2,0.1,0.4,0.1,0.5,0\n\tc0.2-0.1,0.3-0.3,0.3-0.5V8.9l3.6,0c0-1.7-1.4-3-3-3H3C2.2,5.9,1.4,6.2,0.9,6.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol